import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2, Hotel } from "lucide-react";
import { formatErr } from "../lib/constants";

export default function Login() {
  const [email, setEmail] = useState("admin@arsihotels.com");
  const [password, setPassword] = useState("Arsi2026!");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/" : "/puantaj");
    } catch (e) {
      setErr(formatErr(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen jarvis-grid flex items-center justify-center p-6 relative overflow-hidden">
      {/* Decorative orb background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-30 pointer-events-none"
           style={{ background: "radial-gradient(circle, rgba(0,212,255,0.4) 0%, transparent 70%)" }} />

      <div data-testid="login-card" className="glass-card hud-corners w-full max-w-md p-10 relative z-10 scan-overlay">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-full border-2 border-cyan-400 mb-4"
               style={{ boxShadow: "0 0 30px rgba(0,212,255,0.6)" }}>
            <Hotel className="w-8 h-8 text-cyan-300" />
          </div>
          <h1 className="font-display text-3xl font-black text-cyan-300 text-glow tracking-[0.2em]">
            J.A.R.V.I.S.
          </h1>
          <p className="font-mono text-[10px] tracking-[0.3em] text-cyan-400/60 uppercase mt-2">
            Arsi Hotels Command System
          </p>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block font-mono text-xs tracking-widest text-cyan-300/80 uppercase mb-2">E-posta</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 bg-slate-950/60 border border-cyan-500/30 rounded-lg text-white font-mono text-sm focus:border-cyan-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/30 transition"
            />
          </div>
          <div>
            <label className="block font-mono text-xs tracking-widest text-cyan-300/80 uppercase mb-2">Şifre</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 bg-slate-950/60 border border-cyan-500/30 rounded-lg text-white font-mono text-sm focus:border-cyan-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/30 transition"
            />
          </div>
          {err && (
            <div data-testid="login-error" className="text-rose-400 text-sm text-center bg-rose-500/10 border border-rose-500/30 rounded-lg py-2">
              {err}
            </div>
          )}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full btn-cyan py-3 rounded-lg font-display font-bold tracking-widest uppercase text-sm disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Sisteme Giriş
          </button>
        </form>

        <div className="mt-6 pt-4 border-t border-cyan-500/15 text-center">
          <p className="text-xs text-slate-500 font-mono">
            Yetkisiz erişim yasaktır · ARSI Hotels Group
          </p>
        </div>
      </div>
    </div>
  );
}
